module.exports = __webpack_public_path__ + "static/geLightingLogo-de30bed06f859a8e3fac4ccc526d529c.png";